var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type === 'spinner')?_c('spinner'):_vm._e(),(_vm.typeLoader === 'table')?_c('table-loader'):_vm._e(),(_vm.typeLoader === 'section')?_c('section-loader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }